import logging from 'utils/logging';
import Provider from 'provider';
import {
  GAMESTATE_ROUND,
  GAMESTATE_ROUND_FINAL,
  GAMESTATE_ROUNDSTATE_QUESTION_ANSWERING,
} from '../../gamestate/constants';
import { advanceState } from '../../gamestate/GameState';
import { registerCacheReset } from '../momentCacheManager';

const log = logging.getLogger('moments.FinalAnsweringTimeout');
log.setLevel('info');

let triggered = false;

const resetTriggered = () => { triggered = false; };
registerCacheReset('round', resetTriggered);

/**
 * Trigger-only moment (no narration). Auto-advances to question.judging
 * when the answering timer expires for the final round.
 */
export const FinalAnsweringTimeoutTrigger = {
  id: 'FINAL_ANSWERING_TIMEOUT',
  shouldTrigger: ({ currentState }) => {
    if (triggered) return false;

    if (currentState?.currentState !== GAMESTATE_ROUND) return false;
    if (currentState?.round !== GAMESTATE_ROUND_FINAL) return false;
    if (currentState?.roundState !== GAMESTATE_ROUNDSTATE_QUESTION_ANSWERING) return false;

    // Check if the timer has expired
    const endTime = currentState?.endTime;
    if (!endTime) return false;

    const now = new Date();
    const end = new Date(endTime);

    if (now >= end) {
      triggered = true;
      log.info('Final answering timeout reached, auto-advancing to judging');

      return {
        shouldTriggerAction: true,
        shouldGenerateNarration: false,
        triggerAction: FinalAnsweringTimeoutTrigger.triggerAction,
      };
    }

    return false;
  },

  triggerAction: async (gameObject, players, dispatch) => {
    log.info('Answering timeout, advancing to judging');
    // Backup path: same auto-close the UI countdown does, in case the
    // gameboard isn't mounted. Idempotent — safe if both paths run.
    try {
      const gameId = gameObject.id;
      const questionId = gameObject.state?.questionId;
      if (gameId && questionId) {
        await Provider.closeQuestionSubmissions(gameId, questionId);
      }
    } catch (error) {
      log.error('Error closing submissions in FinalAnsweringTimeout:', error);
    }
    try {
      await advanceState(gameObject, players, dispatch);
    } catch (error) {
      log.error('Error advancing after answering timeout:', error);
    }
  },
};

// No playback
export const FinalAnsweringTimeoutPlayback = {
  id: 'FINAL_ANSWERING_TIMEOUT_PLAYBACK',
  momentType: null,
  shouldPlay: () => false,
};

const api = {
  trigger: FinalAnsweringTimeoutTrigger,
  playback: FinalAnsweringTimeoutPlayback,
};

export default api;
